export enum ConditionalType {
  default = "default",
  operation = "operation",
}
